// extracted by extract-css-chunks-webpack-plugin
module.exports = {"tableSimple":"JcbmXZ","heading":"_3vHpIw","table":"_182-El","tr":"_1wSPQi","td":"_2fO2EH","th":"_1c2bJI","thead":"_136xqo"};